// extracted by mini-css-extract-plugin
export default {"primary":"#003a74","secondary":"#0b72d9","error":"#d15744","toggelStyle":"Toggelbutton_toggelStyle__X8-4E","selectedDay":"Toggelbutton_selectedDay__ngrrL"};